import { render, staticRenderFns } from "./PrivilegeCategoryDetail.vue?vue&type=template&id=a7dd6b54&scoped=true"
import script from "./PrivilegeCategoryDetail.vue?vue&type=script&lang=js"
export * from "./PrivilegeCategoryDetail.vue?vue&type=script&lang=js"
import style0 from "./PrivilegeCategoryDetail.vue?vue&type=style&index=0&id=a7dd6b54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7dd6b54",
  null
  
)

export default component.exports